export { default } from "./RecommendedListings";
